import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '../layout/buttons';
import styles from './VoiceComplete.module.css';

const VoiceNotHeard = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [interviewUrl, setInterviewUrl] = useState('');

    useEffect(() => {
        const url = searchParams.get('interviewUrl');
        if (url) {
            setInterviewUrl(url);
        }
    }, [searchParams]);

    const handleRetakeInterview = () => {
        if (interviewUrl) {
            window.location.href = interviewUrl;
        } else {
            // Fallback to interview page if no URL provided
            navigate('/interview');
        }
    };

    return (
        <div className={styles.authContainer}>
            <h1 className={styles.authTitle}>We're sorry you didn't feel heard.</h1>
            <h3>Your experience matters, and we're committed to creating better conversations. Thank you for giving us the opportunity to improve.</h3>
            <p style={{ marginTop: '1rem', fontSize: '16px', color: 'var(--text-secondary, #6c757d)' }}>
                If you'd like to try again, you can start the interview from the beginning.
            </p>
            
            {interviewUrl && (
                <div style={{ marginTop: '2rem' }}>
                    <Button 
                        onClick={handleRetakeInterview}
                        style={{
                            backgroundColor: 'var(--brand-as-purple-600)',
                            border: 'none',
                            padding: '12px 24px',
                            fontSize: '16px',
                            borderRadius: '8px',
                            cursor: 'pointer'
                        }}
                    >
                        Retake Interview
                    </Button>
                </div>
            )}
        </div>
    );
};

export default VoiceNotHeard;
